RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const ESCAPE_KEY_CODE = 27;

    const MultiTokenItem = RivalIQ.views.ItemView.mixin({
        tagName: 'li',
        className: 'connected-token',
        template: '#multiTokenItemTemplate',

        behaviors: {
            AttributeBuilder: {}
        },

        mixins: [views.DisconnectTokenMixin],

        ui: {
            disconnectBtn: '.x-disconnect',
            resyncLink: '.x-resync-connection',
            disconnectToken: '.x-disconnect-btn',
            popovers: '[data-toggle="popover"]'
        },

        events: {
            'click @ui.disconnectBtn': 'disconnect',
            'click @ui.resyncLink': 'resync'
        },

        serializeData: function () {
            const me = this;
            me.model.set('uniqueKeyPart', me.model.get('user_id'));
            const followedCompany = (Boolean(me.model.get('iconUrl')));

            let propertyName = me.model.get('name');
            if (me.model.get('channel') === 'twitter') {
                propertyName = 'Twitter Analytics';
                me.model.set('propertyName', propertyName);
            } else if (me.model.get('channel') === 'tiktok') {
                propertyName = 'TikTok Insights';
                me.model.set('propertyName', propertyName);
            }

            const oauthUrl = me.options.oauthUrl + encodeURIComponent(`&fromReconnect=true&screenName=${me.model.get('screen_name')}&buttonSource=${RivalIQ.enums.sources[me.model.get('source')]}`);
            return _.extend(me.model.toJSON(),
                {
                    oauthUrl: oauthUrl,
                    followedCompany: followedCompany,
                    protected: me.model.get('protected') || false,
                    hasConnectedPages: false,
                    connectionExplainer: ''
                }
            );
        },

        onRenderLoaded: function () {
            const me = this;

            if (me.model.get('expired') || me.model.get('userOwnsExpiredToken')) {
                me.$el.addClass('account-expired');
            }

            me.ui.popovers.popover({
                container: 'body',
                trigger: 'hover',
                placement: 'top',
                html: true
            });
        },

        templateHelpers: function () {
            return {
                impersonated: RivalIQ.state.account.isImpersonated
            };
        },

        displayDisconnectMsg: function (message) {
            const me = this;

            if (me.$el.hasClass('disconnect-btn')) {
                me._execDisconnect();
            } else {
                me.ui.disconnectToken.find('.btn-connect').text('Confirm Disconnect');
                me.ui.disconnectToken.find('.btn-warn-msg').text(message);
                me.$el.addClass('disconnect-btn');
            }
        },

        restoreFromDisconnectMode: function () {
            const me = this;
            me.ui.disconnectToken.find('.btn-connect').text('Disconnect');
            me.$el.removeClass('disconnect-btn');
        }
    });

    // REQUIRED OPTIONS:
    // model: Backbone Channel model ( RivalIQ.data.channels.get(source); )
    //
    // OPTIONAL:
    // parentItem: parent container to be rendered when a token is added / removed
    views.MultiTokenConnectionModal = RivalIQ.views.CompositeView.mixin({

        className: 'modal',
        template: '#multiTokenConnectionTemplate',

        attributes: {
            'data-keyboard': false,
            tabindex: '-1'
        },

        initialize: function () {
            const me = this;

            // modal displays unique handles
            const tokens = _.map(me.model.getUniqueConnections(), function (token) {
                return token.toJSON();
            });

            // HACK HACK
            // FIXME: this should useMaxTokenName, but only twitter has been setup yet so 'twitter_max_tokens' is used
            // const maxTokenName = `${me.model.get('channel')}_max_tokens`;
            // eslint-disable-next-line dot-notation
            me.model.set('maxMultiTokens', RivalIQ.state.account.get('plan')['twitter_max_tokens']);

            me.collection = new Backbone.Collection(_.sortBy(tokens, function (token) { return token.screen_name.toLowerCase?.(); }));
        },

        ui: {
            body: '.modal-body',
            connectTokenColumn: '.connect-token',
            addTokenBtn: '.x-add-token',
            popovers: '[data-toggle="popover"]',
            btnDone: '.x-close'
        },

        events: {
            'click': 'onClick',
            'keydown': 'onKeydown',
            'click @ui.btnDone': 'onClickDone'
        },

        onClickDone: function () {
            const me = this;

            if (me.tokenDisconnected) {
                me.trigger('click:done');
            }
        },

        onClick: function (e) {
            const me = this;

            if (!me.$(e.target).hasClass('x-disconnect')) {
                me.restoreChildren();
            }
        },

        onKeydown: function (e) {
            const me = this;

            if (e.which === ESCAPE_KEY_CODE) {
                e.preventDefault();
                me.restoreChildren();
            }
        },

        restoreChildren: function () {
            const me = this;
            me.children.each(function (view) {
                view.restoreFromDisconnectMode();
            });
        },

        serializeData: function () {
            const me = this;

            let propertyName = me.model.get('name');
            if (me.model.get('channel') === 'twitter') {
                propertyName = 'Twitter Analytics';
                me.model.set('propertyName', propertyName);
            } else if (me.model.get('channel') === 'tiktok') {
                propertyName = 'TikTok Insights';
                me.model.set('propertyName', propertyName);
            }

            const source = me.model.get('source');
            const name = RivalIQ.data.channels.getPlatformName(source);
            const oauthUrl = RivalIQ.channels.getOAuthUrl(me.model.get('source'));

            return _.extend(me.model.toJSON(), {
                name: name,
                oauthUrl: oauthUrl,
                tokenCount: me.collection.models.length,
                hasConnectedPages: false,
                connectionExplainer: ''
            });
        },

        templateHelpers: function () {
            return {
                impersonated: RivalIQ.state.account.isImpersonated
            };
        },

        onRenderLoaded: function () {
            const me = this;

            if (RivalIQ.state.account.isImpersonated()) {
                me.ui.addTokenBtn.addClass('disabled');
                me.ui.addTokenBtn.prop('disabled', true);
            }

            const tokenCount = _.size(me.collection.models);
            if (tokenCount === 0) {
                me.ui.body.addClass('no-tokens');
            } else if (tokenCount >= me.model.get('maxMultiTokens')) {
                me.ui.connectTokenColumn.addClass('max-out-tokens');
                me.ui.addTokenBtn.attr('disabled', 'disabled');
            }

            me.ui.popovers.popover({
                content: `<a onclick="handleIntercomChat()">Contact support</a> to add more ${insightsString(me.model.get('channel'))} accounts to your plan.`,
                html: true,
                container: me.ui.popovers
            });
        },

        childView: MultiTokenItem,
        childViewContainer: '.x-token-body',
        childViewOptions: function (model) {
            const me = this;

            const options = {};
            model.set('channel', me.model.get('channel'));
            options.curation = me.model;
            options.oauthUrl = RivalIQ.channels.getOAuthUrl(me.model.get('source'));

            return options;
        },
        childEvents: {
            'edit:cancel': 'onEditCancel',
            'child:deleted': 'reloadWidget'
        },

        reloadWidget: function () {
            const me = this;

            me.initialize();

            // render the connected accounts grid
            if (me.options.parentItem) {
                me.options.parentItem.render();
            }

            me.render();
        },

        eventsNotToDebounce: {
            'keydown': 'onKeydown'
        }
    });
});

function insightsString(channel) {
    switch (channel) {
        case 'twitter':
            return 'Twitter Analytics';
        case 'tiktok':
            return 'TikTok Insights';
        default:
            return 'Insights';
    }
}
